const defaultCompare = <T>(a: T, b: T): number => {
  if (typeof a === 'string' && typeof b === 'string') {
    return stringCompareNumeric(a, b);
  }
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  }

  return 0;
};

export const stringCompare = (a: string, b: string): number => {
  // eslint-disable-next-line aveny/locale-compare-sort-rule
  return a.localeCompare(b, 'sv', {
    sensitivity: 'base',
  });
};

export const stringCompareNumeric = (a: string, b: string): number => {
  // eslint-disable-next-line aveny/locale-compare-sort-rule
  return a.localeCompare(b, 'sv', {
    numeric: true,
    sensitivity: 'base',
  });
};

export const numberCompare = (
  a: number,
  b: number,
  order?: 'asc' | 'desc'
): number => {
  return order ? (order === 'asc' ? a - b : b - a) : a - b;
};

const mergeSort = <T>(
  list: T[],
  compareFunction?: (a: T, b: T) => number
): T[] => {
  const cmp = compareFunction || defaultCompare;

  if (list.length <= 1) {
    return list;
  }

  const mid = Math.ceil(list.length / 2);

  let left = list.slice(0, mid);
  let right = list.slice(mid);

  if (mid > 1) {
    left = mergeSort(left, cmp);
    right = mergeSort(right, cmp);
  }

  return merge(left, right, cmp);
};

const merge = <T>(list1: T[], list2: T[], cmp: (a: T, b: T) => number): T[] => {
  const result: T[] = [];

  while (list1.length > 0 && list2.length > 0) {
    const cmpResult = cmp(list1[0], list2[0]);
    if (cmpResult <= 0) {
      result.push(list1[0]);
      list1.shift();
    } else {
      result.push(list2[0]);
      list2.shift();
    }
  }

  while (list1.length > 0) {
    result.push(list1[0]);
    list1.shift();
  }
  while (list2.length > 0) {
    result.push(list2[0]);
    list2.shift();
  }

  return result;
};

export default mergeSort;
